// Petnoya Phosphor Duotone hydrator.
// Replaces every <i class="ph-duotone ph-*"></i> with the real duotone SVG
// fetched from the Phosphor core CDN. Required because the Phosphor CSS-font
// path is unreliable when content-security policies strip pseudo-element
// `content` declarations. See docs/design-system/HANDOVER-icon-switch.md.
(function () {
  // Icons served from the theme itself (no CDN request). Phosphor has no
  // "-fill-duotone" file, so star-fill used to 404 and the review stars vanished.
  const cache = {
    'star-fill': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M234.29,114.85l-45,38.83L203,211.75a16.4,16.4,0,0,1-24.5,17.82L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,59,4.76a16.46,16.46,0,0,1,9.37,28.86Z"/></svg>',
  };
  const SKIP_CLASSES = new Set([
    'ph-duotone', 'ph-fill', 'ph-bold', 'ph-light', 'ph-thin', 'ph-regular',
  ]);

  async function hydrate() {
    const els = document.querySelectorAll('i[class*="ph-"]');
    for (const el of els) {
      if (el.dataset.phHydrated) continue;
      const cls = [...el.classList].find(
        c => c.startsWith('ph-') && !SKIP_CLASSES.has(c)
      );
      if (!cls) continue;
      const name = cls.slice(3);
      if (cache[name] === null) continue; // failed before: do not retry on every DOM change
      try {
        if (!cache[name]) {
          const isFill = name.endsWith('-fill');
          const r = await fetch(
            'https://unpkg.com/@phosphor-icons/core@2.1.1/assets/' +
            (isFill ? 'fill/' + name : 'duotone/' + name + '-duotone') + '.svg'
          );
          if (!r.ok) { cache[name] = null; continue; }
          cache[name] = await r.text();
        }
        el.innerHTML = cache[name];
        const svg = el.querySelector('svg');
        if (svg) {
          svg.setAttribute('width', '1em');
          svg.setAttribute('height', '1em');
          svg.style.verticalAlign = '-0.15em';
          svg.querySelectorAll('path').forEach(p => {
            if (!p.getAttribute('fill') || p.getAttribute('fill') === 'currentColor') {
              p.setAttribute('fill', 'currentColor');
            }
          });
        }
        el.dataset.phHydrated = '1';
      } catch (e) {
        cache[name] = null; // Network/CORS failed — Phosphor CSS-font fallback will render.
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
  new MutationObserver(() => hydrate()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
